// @flow

import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import CustomEvent from 'custom-event';
import MapOverlayPoint from 'MapOverlayPoint';
import MapStoryPoint from 'MapStoryPoint';
import MapEventPoint from 'MapEventPoint';
import GMapStyle from './google-map-style.json';
import MapQuery from './MapQuery';
import ZoomControl from './ZoomControl';

class GMap extends PureComponent {
  static defaultProps = {
    gapiKey: '',
    stories: {
      entities: [],
    },
    events: {
      entities: [],
    },
  };

  static propTypes = {
    gapiKey: PropTypes.string.isRequired,
    stories: PropTypes.shape({
      entities: PropTypes.arrayOf(
        PropTypes.shape({
          entityLabel: PropTypes.string.isRequired,
          fieldSubtitle: PropTypes.string.isRequired,
          fieldShortDescription: PropTypes.string.isRequired,
          fieldThemeColor: PropTypes.string.isRequired,
          fieldLocation: PropTypes.string,
          fieldImage3: PropTypes.string.isRequired,
          entityUrl: PropTypes.shape({
            alias: PropTypes.string.isRequired,
          }),
        }),
      ),
    }),
    events: PropTypes.shape({
      entities: PropTypes.arrayOf(
        PropTypes.shape({
          entityLabel: PropTypes.string.isRequired,
          fieldDate: PropTypes.string.isRequired,
          fieldImage: PropTypes.string.isRequired,
          fieldLocation: PropTypes.string.isRequired,
          body: PropTypes.string.isRequired,
        }),
      ),
    }),
  };

  constructor(props) {
    super(props);

    this.markers = [];
    this.mapInitialized = false;
    this.centerPoint = false;
  }

  componentDidMount() {
    if (this.props.gapiKey !== '') {
      if (global.document.getElementById('gmaps-api') === null) {
        global.initMap = this.initializeMap.bind(this);

        const s = global.document.createElement('script');
        s.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${this.props
          .gapiKey}&callback=window.initMap`;
        s.type = 'text/javascript';
        s.id = 'gmaps-api';
        global.document.getElementsByTagName('head')[0].appendChild(s);
      } else {
        this.initializeMap();
      }
    }
  }

  initializeMap() {
    /* eslint-disable no-new, global-require */
    if (!this.mapInitialized) {
      this.centerPoint = new global.google.maps.LatLng(38.743, -90.289);

      const width =
        global.innerWidth ||
        global.document.documentElement.clientWidth ||
        global.document.body.clientWidth;

      const styledMap = new global.google.maps.StyledMapType(GMapStyle);
      const mapOptions = {
        center: this.centerPoint,
        disableDefaultUI: true,
        zoom: width > 768 ? 15 : 13,
        minZoom: 3,
        maxZoom: 20,
        scrollwheel: true,
      };

      this.map = new global.google.maps.Map(this.mapDiv, mapOptions);
      global.googleMap = this.map;

      // Associate the styled map with the MapTypeId and set it to display.
      this.map.mapTypes.set('styled_map', styledMap);
      this.map.setMapTypeId('styled_map');

      // Add custom zoom controls
      const zoomControlDiv = global.document.createElement('div');
      new ZoomControl(zoomControlDiv, this.map);

      zoomControlDiv.index = 1;
      this.map.controls[global.google.maps.ControlPosition.RIGHT_CENTER].push(
        zoomControlDiv,
      );

      const CustomMarker = require('./CustomMarker').default;

      // Add static marker for where Michael Brown was shot.
      new CustomMarker(
        new global.google.maps.LatLng(38.73847, -90.27387),
        this.map,
        {
          markup: <MapOverlayPoint text="Michael Brown was killed" />,
        },
      );

      this.mapInitialized = true;
      this.popuplateMap();
    }
  }

  popuplateMap() {
    /* eslint-disable no-new, global-require */
    this.clearMap();

    if (
      this.mapInitialized &&
      (this.props.stories.entities.length > 0 ||
        this.props.events.entities.length > 0)
    ) {
      const CustomMarker = require('./CustomMarker').default;

      // Add story and event data points.
      const points = this.props.stories.entities.concat(
        this.props.events.entities,
      );
      for (let i = 0; i < points.length; i += 1) {
        const point = points[i];
        // Only stories have a URL.
        const isStory = Object.prototype.hasOwnProperty.call(
          point,
          'entityUrl',
        );

        if (point.fieldLocation) {
          const location = JSON.parse(point.fieldLocation.toString('utf-8'));
          const latlng = new global.google.maps.LatLng(
            location[0].lat,
            location[0].lng,
          );

          this.markers.push(
            new CustomMarker(latlng, this.map, {
              markup: isStory
                ? <MapStoryPoint
                  {...point}
                  map={this.map}
                  history={this.props.history}
                />
                : <MapEventPoint {...point} map={this.map} />,
              hasMouseEvents: true,
            }),
          );
        }
      }
    }
  }

  clearMap() {
    for (let i = 0; i < this.markers.length; i += 1) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }

  render() {
    this.popuplateMap();
    return (
      <main className="site-content site-content--bottom-left-gradient">
        <Helmet title="Map">
          <meta property="og:title" content="Map | Ferguson Voices" />
          <link rel="dns-prefetch" href="//maps.googleapis.com" />
        </Helmet>
        <div
          role="presentation"
          className="site-content__screen site-content__screen--fixed"
          onClick={event => {
            if (this.map && event.target.tagName.toLowerCase() !== 'button') {
              this.map.setOptions({ scrollwheel: true });
              global.dispatchEvent(new CustomEvent('mapModalsClosed'));
            }
          }}
        >
          <div ref={elem => (this.mapDiv = elem)} id="map" className="map" />
        </div>
      </main>
    );
  }
}

export default MapQuery(withRouter(GMap));



// WEBPACK FOOTER //
// ./screens/App/screens/GMap/component.js